import React from "react";
import { Box, MenuItem, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import EditIcon from "@icons/myicons/edit.svg?react";
import DeleteIcon from "@icons/myicons/trash-delete-bin-2.svg?react";
import { ButtonWithActionMenu } from "@components/ButtonWithActionMenu";

interface BookingActionMenuItemsProps {
  onEdit?: () => void;
  onDelete: () => void;
  showEdit: boolean;
  handleCloseMenu?: () => void;
}

const BookingActionMenuItems = ({
  onEdit,
  onDelete,
  showEdit,
  handleCloseMenu,
}: BookingActionMenuItemsProps) => {
  const { t } = useTranslation();

  const handleEditClick = () => {
    onEdit?.();
    handleCloseMenu?.();
  };

  const handleDeleteClick = () => {
    onDelete();
    handleCloseMenu?.();
  };

  return (
    <>
      {showEdit && (
        <MenuItem
          onClick={handleEditClick}
          data-testid="edit-booking-menu-item"
        >
          <Box display="flex" alignItems="center" gap={3}>
            <EditIcon width={20} height={20} />
            <Typography variant="body3">
              {t("investment.protocolTable.actions.edit")}
            </Typography>
          </Box>
        </MenuItem>
      )}
      <MenuItem
        onClick={handleDeleteClick}
        data-testid="delete-booking-menu-item"
      >
        <Box display="flex" alignItems="center" gap={3} color="error.main">
          <DeleteIcon />
          <Typography variant="body3">
            {t("investment.protocolTable.actions.delete")}
          </Typography>
        </Box>
      </MenuItem>
    </>
  );
};

interface Props {
  onEdit?: () => void;
  onDelete: () => void;
  showEdit: boolean;
}

export const BookingActionMenu = (props: Props) => (
  <ButtonWithActionMenu testId="booking-action-menu-button">
    <BookingActionMenuItems {...props} />
  </ButtonWithActionMenu>
);
